import { UnstyledButton } from "src/ui";
import { GroupedTableGroupRowProps } from "./GroupedTableGroupRow.types";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import classNames from "classnames";
import { SmallBody } from "src/components/Text";
import { CSSProperties } from "react";

function GroupedTableGroupRow<TRow>({
    columns,
    indentPx,
    group,
    isExpanded,
    toggle,
    groupStyle = "default",
}: GroupedTableGroupRowProps<TRow>): JSX.Element {
    const isCompact = groupStyle === "compact";

    const iconName = isCompact
        ? "arrow-down-s-fill"
        : (isExpanded ? "arrow-up-2" : "arrow-down-1");

    return (
        <div className={classNames("GroupedTableGroupRow", {
            "GroupedTableGroupRow-compact": isCompact, })}>
            {columns.map((column, index) => {
                const style: CSSProperties = {};
                
                if (column.width) {
                    style.width = isNaN(+column.width)
                        ? column.width
                        : `${column.width}px`;
                    style.flexBasis = style.width;
                }
                        
                if (index === 0) {
                    style.paddingLeft = indentPx;

                    return (
                        <div className="GroupedTableGroupRow-column"
                             key={`${group.id}-${String(column.id)}`}
                             style={style}>
                            <div className="GroupedTableGroupRow-label">
                                <UnstyledButton className={classNames("GroupedTableGroupRow-toggle", {
                                    lightPrimaryBGColor: !isCompact, })}
                                                onClick={toggle}>
                                    <Visage2Icon className="GroupedTableGroupRow-toggleIcon"
                                                 icon={iconName}
                                                 color={isCompact ? "spintrGrey" : undefined}
                                                 type={isCompact ? "custom" : "outline"}
                                                 rotation={isCompact
                                                    ? (isExpanded ? 180 : 0)
                                                    : undefined}
                                                 size={isCompact ? "medium" : "small"} />
                                </UnstyledButton>
                                <SmallBody color="contentDark" weight={isCompact ? "medium" :  "regular"}>
                                    {group.label}
                                </SmallBody>
                            </div>
                        </div>
                    );
                }

                return (
                    <div className="GroupedTableGroupRow-column"
                         key={`${group.id}-${String(column.id)}`}
                         style={style}>
                        {column.groupCell
                            ? column.groupCell(group)
                            : null}
                    </div>
                );
            })}
        </div>
    );
}

export default GroupedTableGroupRow;
